import {ListProvider} from "base/entity/provider";
import {ModuleLayout} from "base/ui/module/components";
import {ModuleConfigProvider} from "base/ui/module/provider";
import {DomainProvider} from "snimf/domain/provider";
import {HolderPageMenu} from "holder/menu";

const HoldersModule = () => {
    return (
        <ModuleConfigProvider>
            <DomainProvider>
                <ListProvider>
                    <ModuleLayout menu={<HolderPageMenu />} />
                </ListProvider>
            </DomainProvider>
        </ModuleConfigProvider>
    );
};

export default HoldersModule;
